<template>
    <div class="content">
        <div class="row text-left px-md-5">
            <div class="col-md-4" v-if="contactData.location">
                <span class="font-bold d-block heading-text">LOCATION </span>
                <span class="d-block" v-for="(item, index) in contactData.location.split('\n')"
                    :key="index" v-html="item"></span>
            </div>
            <div class="col-md-4" v-if="contactData.phone">
                <span class="font-bold d-block heading-text">PHONE</span>
                <span class="d-block" v-for="(item, index) in contactData.phone.split('\n')"
                    :key="index" v-html="item"></span>
            </div>
            <div class="col-md-4" v-if="contactData.email">
                <span class="font-bold d-block heading-text">E-MAIL</span>
                <span class="d-block">{{ contactData.email }}</span>
            </div>
        </div>
        <hr />
        <div class="row address-info text-left" v-if="contactOfficesRow1">
            <div class="col pt-2 address-item" v-for="(office, index) in contactOfficesRow1.sort((a, b) => a.ordering - b.ordering)"
                :key="index" :class="{'col-md-3 pl-md-0': office.title.rendered.includes('LEKKI')}">
                <span class="font-bold d-block heading-text">{{ office.title.rendered }}</span>
                <span class="d-block" v-for="(address, adIndex) in office.address_information.split('\n')"
                :key="adIndex" v-html="address"></span>
            </div>
        </div>
        <hr />
        <div class="row address-info text-left" v-if="contactOfficesRow2">
            <div class="col pt-2 address-item" v-for="(office, index) in contactOfficesRow2.sort((a, b) => a.ordering - b.ordering)"
                :key="index">
                <span class="font-bold d-block heading-text">{{ office.title.rendered }}</span>
                <span class="d-block" v-for="(address, adIndex) in office.address_information.split('\n')"
                :key="adIndex" v-html="address"></span>
            </div>
            <div class="col pt-2 address-item" v-if="contactData.location && ! contactOfficesRow3.length">
                <span class="font-bold d-block heading-text">SALES HOTLINES: </span>
                <span class="d-block" v-for="(item, index) in contactData.sales_hotline.split('\n')"
                    :key="index" v-html="item"></span>
            </div>
        </div>
        <hr v-if="contactOfficesRow3.length" />
        <div class="row address-info text-left" v-if="contactOfficesRow3.length">
            <div class="col pt-2 address-item" v-for="(office, index) in contactOfficesRow3.sort((a, b) => a.ordering - b.ordering)"
                :key="index">
                <span class="font-bold d-block heading-text">{{ office.title.rendered }}</span>
                <span class="d-block" v-for="(address, adIndex) in office.address_information.split('\n')"
                :key="adIndex" v-html="address"></span>
            </div>
            <div class="col pt-2 address-item" v-if="contactData.location && contactOfficesRow3.length">
                <span class="font-bold d-block heading-text">SALES HOTLINES: </span>
                <span class="d-block" v-for="(item, index) in contactData.sales_hotline.split('\n')"
                    :key="index" v-html="item"></span>
            </div>

        </div>
    </div>    
</template>

<script>
export default {
    name: "ContactFooter",
    computed: {
        currentYear() {
            return new Date().getFullYear()   
        },
        contactData() {
            return this.$store.state.contactData
        },
        contactOfficesRow1() {
            return this.$store.state.contactOffices ? 
                this.$store.state.contactOffices.filter((item, index) => index <= 3) : []
        },
        contactOfficesRow2() {
            return this.$store.state.contactOffices ? 
                this.$store.state.contactOffices.filter((item, index) => index > 3) : []
        },
        contactOfficesRow3() {
            return this.$store.state.contactOffices && this.$store.state.contactOffices.length > 7 ? 
                this.$store.state.contactOffices.filter((item, index) => index > 6) : []
        }
    }
}
</script>

<style scoped>
.content {
    border-radius: 7px;
    margin: 30px 0;
    background: #909090;
    color: #fff;
    padding: 20px;
}
@media (min-width: 1200px) {
    .content {
        padding: 40px 70px;
    }
    .address-info {
        padding-left: 4%;
        padding-right: 4%;
    }
}
hr {
    border-top: 1px solid #fff;
    margin: 40px 0;
}
@media (max-width: 768px) {
    hr {
        margin: 15px 0;
    }
    .address-item {
        flex: 0 0 50%;
        max-width: 50%;
    }
}
@media (max-width: 576px) {
    .address-item {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
.heading-text {
    margin-bottom: 5px;
}
</style>